import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BannerState } from '../../@mrkt/features/Banner';
import { Track } from '../Tracking';
import { Layout } from './Layout';
import { LayoutState } from './LayoutState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Page = function Page(ctx) {
  var props = ctx.props,
      Component = ctx.Component;
  return /*#__PURE__*/_jsx(Track, {
    children: /*#__PURE__*/_jsx(BannerState, {
      children: /*#__PURE__*/_jsx(LayoutState, {
        preview: props === null || props === void 0 ? void 0 : props.preview,
        children: /*#__PURE__*/_jsxs(Layout, {
          children: [/*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(Component, _objectSpread({}, props))]
        })
      })
    })
  });
};